<template>
  <div v-if="hasFreeOffer">
    <b-alert
      variant="success"
      :show="isValid"
      class="alert-bg"
    >
      <div class="inside-box">
        <div class="p-4 text-center text">
          <!-- eslint-disable -->
          <span v-html="$t('pages.dashboards.employer.free-offer-alert', { offersCount: hasFreeOffer})"></span>
          <!-- eslint-enable -->
          <div style="font-size: 0.8rem">
            {{ $t('pages.dashboards.employer.free-offer-alert-expire', { offerExpirationDateFormatted: offerExpirationDateFormatted}) }}
          </div>
          <div>
            <font-awesome-icon icon="tags" />
          </div>
        </div>
      </div>
    </b-alert>
  </div>
</template>

<script>
export default {
  computed: {
    hasFreeOffer() {
      return this.$auth.user() && this.$auth.user().company && this.$auth.user().company.hasFreeOffer;
    },
    offerExpirationDate() {
      let companyCreatedDate = new Date(this.$auth.user().company.created_at);
      companyCreatedDate.setDate(companyCreatedDate.getDate() + 30);

      return new Date(companyCreatedDate);
    },
    offerExpirationDateFormatted() {
      return this.offerExpirationDate.toLocaleDateString();
    },
    isValid() {
      console.log(this.hasFreeOffer);
      console.log(this.offerExpirationDate);
      console.log(new Date());

      return this.hasFreeOffer && this.offerExpirationDate >= new Date();
    }
  }
}
</script>


<style lang="scss" scoped>
  .inside-box {
    width: 60%;
    height: 90%;
    border-radius: 7px;
    background: #009090;
    margin: auto;

    .text {
      font-size: 1.4rem;

      strong {
        font-size: 1.6rem;
      }
    }
  }
  
  .offer-image {
    width: 100%;
  }
  
  .alert-bg {
    height: 150px;
    display: block;
    position: relative;
    color: white;
  }

  .alert-bg::after {
    content: "";
    background: url(../../../assets/company-home/free-offer-bg.jpg);
    background-size: cover;
    opacity: 0.35;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: 1;   
  }
</style>
